import { B2BClientService, RequestAccessRequest, RequestAccessResult } from '@/b2b/shared/api/server-apis';
import utilities from '@/shared/utilities.service';

export default function useRequestAccess() {
    async function requestAccess(model: RequestAccessModel, recaptchaResponse: string, isSimpleForm: boolean): Promise<RequestAccessResult | undefined> {
        const request: RequestAccessRequest = {
            ...model,
            recaptchaResponse,
        };
        const apiPath = isSimpleForm ? '/api/b2b/request-access-simple' : '/api/b2b/request-access';
        return B2BClientService.requestAccess(request, apiPath).then(utilities.unwrapModel);
    }

    return {
        requestAccess,
    };
}

export type RequestAccessModel = Omit<RequestAccessRequest, 'recaptchaResponse'>

export type RequestAccessFormModel = (InputSelectModel|InputTextModel|InputTelModel|TextareaModel|HeadingModel)[];

export interface HeadingModel {
    type: string;
    classes: string;
    label: string;
}

export interface TextareaModel {
    label: string;
    name: string;
    type: 'textarea';
    validation?: string;
}

export interface InputTextModel {
    label: string;
    name: string;
    type: 'inputText';
    validation?: string;
}

export interface InputTelModel {
    label: string;
    name: string;
    type: 'inputTel';
    validation?: string;
}

export interface InputSelectModel {
    defaultOption?: string;
    displayKey: string;
    label: string;
    name: string;
    options: any[];
    titleKey: string;
    type: 'select';
    valKey: string;
    validation?: string;
    value?: any;
}
